import React from 'react';
import { Heading } from './heading';

interface WarningProps {
  title?: string;
  body: React.ReactNode;
  className?: string;
}

export const Warning: React.FC<WarningProps> = ({ title, body, className = '' }) => {
  return (
    <div
      className={`tw:mb-3 tw:p-4 tw:bg-warning-bg tw:border tw:border-warning-border tw:rounded-lg tw:dark:bg-warning-bg-dark tw:dark:border-warning-border-dark ${className}`}
    >
      <div className="tw:flex tw:items-center tw:gap-3">
        <div className="tw:flex-shrink-0">
          <i className="fas fa-exclamation-triangle tw:text-warning-text tw:dark:text-warning-text-dark tw:mt-0.5" />
        </div>
        <div className="tw:flex-1">
          {title ? (
            <>
              <Heading
                level={4}
                className="tw:text-warning-text tw:dark:text-warning-text-dark tw:!mb-2"
              >
                {title}
              </Heading>
              <div className="tw:text-sm tw:text-warning-text tw:dark:text-warning-text-dark">
                {body}
              </div>
            </>
          ) : (
            <div className="tw:text-sm tw:text-warning-text tw:dark:text-warning-text-dark tw:mb-0">
              {body}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
